import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IGeography } from '@/interfaces/geography';
import { SearchOutlined } from '@ant-design/icons';
import GeographySelectorModal from '../geography/geography-selector-modal';

interface IProps {
  size?: SizeType;
  handleSelectData: (item: IGeography, locale: 'th' | 'en') => void;
}

const GeographySelector = ({ size = 'large', handleSelectData }: IProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="ค้นหา">
        <Button
          size={size}
          icon={<SearchOutlined />}
          title="ค้นหา"
          onClick={() => setOpen(true)}
        />
        <GeographySelectorModal
          handleCancel={() => setOpen(false)}
          handleOk={(item, locale) => {
            handleSelectData(item, locale);
            setOpen(false);
          }}
          open={open}
        />
      </Tooltip>
    </>
  );
};

export default GeographySelector;
